import React from "react";
import PropTypes from "prop-types";

import Question from "../question/Question";
import C from "../../constants";
import "./BarcodeScanner.css";
import strings from "../../resources/strings";
import _ from "lodash";

const appCfg = require("../../config");

const Dynamsoft = window.Dynamsoft;

const driverLicenseFields = {
    DAA: "fullName",
    DAB: "lastName",
    DAC: "firstName",
    DAD: "middleName",
    DAE: "nameSuffix",
    DAF: "namePrefix",
    DAG: "mailingStreetAddress1",
    DAH: "mailingStreetAddress2",
    DAI: "mailingCity",
    DAJ: "mailingState",
    DAK: "mailingPostalCode",
    DAL: "mailingStreetAddress1",
    DAM: "mailingStreetAddress2",
    DAN: "mailingCity",
    DAO: "mailingState",
    DAP: "mailingPostalCode",
    DAQ: "licenseNumber",
    DAR: "licenseClassificationCode",
    DAS: "licenseRestrictionCode",
    DAT: "licenseEndorsementsCode",
    DAU: "height",
    DAV: "heightCm",
    DAW: "weight",
    DAX: "weightKg",
    DAY: "eyeColor",
    DAZ: "hairColor",
    DBA: "licenseExpirationDate",
    DBB: "dateOfBirth",
    DBC: "gender",
    DBD: "issueDate",
    DBE: "issueTime",
    DBF: "numberOfDuplicates",
    DBG: "medicalIndicatorCodes",
    DBH: "organDonor",
    DBI: "nonResidentIndicator",
    DBJ: "uniqueCustomerIdentifier",
    DBK: "socialSecurityNumber",
    DBL: "dateOfBirth",
    DBM: "socialSecurityNumber",
    DBN: "fullName",
    DBO: "lastName",
    DBP: "firstName",
    DBQ: "middleName",
    DBR: "nameSuffix",
    DBS: "namePrefix",
    DCA: "vehicleClass",
    DCB: "restrictions",
    DCD: "endorsements",
    DCE: "physicalDescriptionWeightRange",
    DCF: "documentDiscriminator",
    DCG: "countryOrTerritory",
    DCH: "federalCommercialVehicleCodes",
    DCI: "placeOfBirth",
    DCJ: "auditInformation",
    DCK: "inventoryControlNumber",
    DCL: "raceEthnicity",
    DCM: "standardVehicleClassification",
    DCN: "standardEndorsementCode",
    DCO: "standardRestrictionCode",
    DCP: "jurisdictionSpecificVehicleClassificationDescription",
    DCQ: "jurisdictionSpecific",
    DCR: "jurisdictionSpecificRestrictionCodeDescription",
    DCS: "lastName",
    DCT: "firstName",
    DCU: "suffix",
    DDA: "complianceType",
    DDB: "cardRevisionDate",
    DDC: "hazmatEndorsementExpiryDate",
    DDD: "limitedDurationDocumentIndicator",
    DDE: "familyNameTruncation",
    DDF: "firstNamesTruncation",
    DDG: "middleNamesTruncation",
    DDH: "under18Until",
    DDI: "under19Until",
    DDJ: "under21Until",
    DDK: "organDonorIndicator",
    DDL: "veteranIndicator",
    PAA: "permitClassificationCode",
    PAB: "permitExpirationDate",
    PAC: "permitIdentifier",
    PAD: "permitIssueDate",
    PAE: "permitRestrictionCode",
    PAF: "permitEndorsementCode",
    ZVA: "courtRestrictionCode"
};

class BarcodeScanner extends React.Component {
    /*constructor(props) {
        super(props);
        this.state = {flashOn: false};
        this.toggleFlash = this.toggleFlash.bind(this);
    }*/

    setBarcodeTypes(runtimeSettings, barcodeTypes) {
        let types = barcodeTypes.split(",");

        runtimeSettings.barcodeFormatIds = 0;
        types.forEach(barcodeType => {
            console.debug("barcodeFormatIds: " + runtimeSettings.barcodeFormatIds);
            console.debug(barcodeType.trim());
            switch (barcodeType.trim()) {
                case "PDF417":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_PDF417;
                    break;
                case "AZTEC":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_AZTEC;
                    break;
                case "AII":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_AII;
                    break;
                case "CODABAR":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_CODABAR;
                    break;
                case "CODE_128":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_CODE_128;
                    break;
                case "CODE_39":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_CODE_39;
                    break;
                case "CODE_93":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_CODE_93;
                    break;
                case "DATAMATRIX":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_DATAMATRIX;
                    break;
                case "EAN_13":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_EAN_13;
                    break;
                case "EAN_8":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_EAN_8;
                    break;
                case "INDUSTRIAL_25":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_INDUSTRIAL_25;
                    break;
                case "ITF":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_ITF;
                    break;
                case "OneD":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_ONED;
                    break;
                case "QR_CODE":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_QR_CODE;
                    break;
                case "UPC_A":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_UPC_A;
                    break;
                case "UPC_E":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_UPC_E;
                    break;
                case "GS1_DATABAR":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_GS1_DATABAR;
                    break;
                case "CODE_39_EXTENDED":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_CODE_39_EXTENDED;
                    break;
                case "PATCHCODE":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_PATCHCODE;
                    break;        
                case "MAXICODE":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_MAXICODE;
                    break;
                case "MICRO_QR":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_MICRO_QR;
                    break;                    
                case "MICRO_PDF417":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_MICRO_PDF417;
                    break;
                case "GS1_COMPOSITE":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_GS1_COMPOSITE;
                    break;
                case "MSI_CODE":
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_MSI_CODE;
                    break;
                default:
                    runtimeSettings.barcodeFormatIds |= Dynamsoft.DBR.EnumBarcodeFormat.BF_PDF417;
                    break;
            }
            console.log("barcodeFormatIds: " + runtimeSettings.barcodeFormatIds);
        });
    }

    postProcessField(data, fieldName) {
        if (!data || !fieldName || fieldName.trim().length === 0) {
            return;
        }
        
        switch(fieldName) {
            case "fullName":
                // don't do anything if the field is empty
                if (!data[fieldName] || data[fieldName].trim().length === 0) {
                    return;
                }

                let parts = data[fieldName].split(",");
                if (parts) {
                    data["lastName"] = parts[0].trim();
                    if (parts.length === 3) {
                        data["firstName"] = parts[1].trim();
                        data["middleName"] = parts[2].trim();
                    }
                    else if (parts.length === 2) {
                        data["firstName"] = parts[1].trim();
                    }
                }
            break;
            default:
            break;
        }
    }

    parseDriversLicense(barcodeText) {
        let data = {};
        // offset depends on the type of barcode which is the start of the content we care about
        let index = (barcodeText.indexOf("AAMVA") !== -1) ? 29 : 43;
        let endIndex;

        // do not log personal info
        //console.debug("Barcode text: " + barcodeText);

        while ((endIndex = barcodeText.indexOf("\n", index)) !== -1) {

            let code = barcodeText.substr(index, 3);
            let fieldName = driverLicenseFields[code];
            if (fieldName) {
                let value = barcodeText.substring(index + 3, endIndex);
                if (value && value.trim() !== "" && value !== "NONE") {
                    data[fieldName] = value;
                    this.postProcessField(data, fieldName);
                    // do not log personal info
                    //console.debug("Adding (" + code + "): " + fieldName + ": '" + value + "'");
                } /*else {
                    // do not log personal info
                    console.debug("Skipping (" + code + "): " + fieldName + ": '" + value + "'");
                }*/
            }
            index = endIndex + 1;
        }

        // do not log personal info
        //console.log("JSON: " + JSON.stringify(data));

        return data;
    }

    parseRawData(barcodeText) {
        return {
            data: barcodeText
        };
    }    

    async configureScannerSettings(scanner, barcodeTypes) {
        await scanner.updateVideoSettings({ video: { width: 1280, height: 720, facingMode: "environment" } });
        scanner.bVibrateOnSuccessfulRead = true;

        let runtimeSettings = await scanner.getRuntimeSettings();
        this.setBarcodeTypes(runtimeSettings, barcodeTypes);
        runtimeSettings.localizationModes = [2, 4, 8, 0, 0, 0, 0, 0];
        runtimeSettings.deblurLevel = 2;
        await scanner.updateRuntimeSettings(runtimeSettings);

        let scanSettings = await scanner.getScanSettings();
        // Disregard duplicated results found in a specified time period
        scanSettings.duplicateForgetTime = 20000;
        // Set a interval so that the CPU can relax
        scanSettings.intervalTime = 300;
        await scanner.updateScanSettings(scanSettings);
    }

    getBarcodeTextResultsForDebug() {
        if (_.has(this.props.question, "parse")) {
            switch (this.props.question.parse) {
                case "driversLicense":
                    // eslint-disable-next-line
                    return " @\n\nANSI 636002080002DL00410273ZM03140033DLDCAD\nDCBNONE\nDCDNONE\n\DBA01012023\nDCSTESTER\nDACJOE\nDAD\nDBD01012018\n"
                        + "DBB01011970\nDBC1\nDAYBRO\nDAU068 in\nDAG1 MAIN ST\nDAHNONE\nDAINEW YORK\nDAJNY\nDAK123451111\nDAQS12345678\n"
                        + "DCF01012019 REV 02222016\nDCGUSA\nDDEN\nDDFN\nDDGN\nDCK18049S000000000000\nDDAF\nDDB01112015\nZMZMA603\nZMB01122016\n"
                        + "ZMC\nZMD\nZME\n";
                case "vin":
                default:
                    return "1FTCR10UXTPA78180"; // Sample VIN
            }
        }
        
        return "1FTCR10UXTPA78180"; // Sample VIN
    }

    async handleBarcodeScanResults(barcodeText) {
        let store = this.props.store;

        store.dispatch({ type: C.START_LOADING });

        if (!appCfg.barcodeScanner.debug) {
            /*if (isAndroid && this.state.flashOn) {
                this.toggleFlash(false);
                //window.scanner.turnOffTorch();
            }
            this.setState(() => {
                return {flashOn: false};
            });*/

            let scanner = window.scanner;
            await scanner.hide();
        }

        let data;
        if (_.has(this.props.question, "parse")) {
            switch(this.props.question.parse) {
                case "driversLicense":
                    data = this.parseDriversLicense(barcodeText); // parse driver's license text
                    break;
                case "vin":
                default:
                    data = this.parseRawData(barcodeText); // parse raw text
                    break;
            }
        }
        else {
            data = this.parseRawData(barcodeText); // parse raw text
        }

        store.dispatch({
            type: C.ASSIGN_FROM_CAMERA,
            cameraFields: this.props.question.onCapture.cameraFields,
            cameraResults: data
        });
        store.dispatch({ type: C.RECORD_BILLABLE_OPERATION, operation: "barcodeScan", count: 1 });
        store.dispatch({ type: C.STOP_LOADING });
        store.dispatch({ type: C.NEXT_QUESTION });
    }

    async showScanner(barcodeTypes) {
        if (appCfg.barcodeScanner.debug) {
            return;
        }
                
        let scanner = window.scanner;
        if (!scanner) {
            let self = this;
            let store = this.props.store;

            store.dispatch({ type: C.START_LOADING, loadingText: strings.getString("loadingScanner") });

            Dynamsoft.DBR.BarcodeReader.license = appCfg.barcodeScanner.license;

            scanner = await Dynamsoft.DBR.BarcodeScanner.createInstance({
                UIElement: document.getElementById("barcodeScanner"),
                onFrameRead: results => {
                    console.log(results);
                },
                onUnduplicatedRead: async (barcodeText) => {
                    console.log(barcodeText);
                    self.handleBarcodeScanResults(barcodeText);
                }
            });

            window.scanner = scanner;
            /*self.setState(state => ({
                scanner: scanner
            }));*/

            await this.configureScannerSettings(scanner, barcodeTypes);

            store.dispatch({ type: C.STOP_LOADING });
        }

        try {
            await scanner.show();
        }
        catch(ex) {
            console.log(ex);
            alert(ex.message || ex);
            await scanner.hide();
        }

        document.getElementsByClassName('dce-btn-close')[0].hidden = true;
        document.getElementsByClassName('dce-sel-camera')[0].hidden = true;
        document.getElementsByClassName('dce-sel-camera')[0].style.display = "none";
        document.getElementsByClassName('dce-sel-resolution')[0].hidden = true;
        document.getElementsByClassName('dce-sel-resolution')[0].style.display = "none";
    }

    toggleFlash(changeTo) {
        /*if (isAndroid && has(this.state, "scanner")) {
            let self = this;
            if (changeTo) {
                console.log("Setting state, flashOn: " + changeTo);
                this.setState(() => {
                    return {flashOn: changeTo};
                });
            }
            else {
                console.log("Setting state, flashOn: " + !this.state.flashOn);
                this.setState(() => {
                    return {flashOn: !self.state.flashOn};
                });
            }
        }*/
    }

    componentDidUpdate() {
        /*if (isAndroid && has(this.state, "scanner")) {
            console.log("Flash: " + (this.state.flashOn ? "Turning on" : "Turning off"));
            this.state.flashOn ? window.scanner.turnOnTorch() : window.scanner.turnOffTorch();
        }*/
    }

    componentDidMount() {
        let barcodeTypes = this.props.question.barcodeTypes || "PDF417";

        this.showScanner(barcodeTypes);
    }

    render() {
        let question = this.props.question;

        // only display the flash button on non-iOS devices
        let flashButton = null; /*isIOS ? null :
            (<button id="flashButton" onClick={() => this.toggleFlash()} className="w3-button w3-block w3-center w3-indigo w3-small w3-padding-large">
                {this.state.flashOn ? "Turn Flash Off" : "Turn Flash On"}
            </button>
            );*/

        if (appCfg.barcodeScanner.debug) {
            return (
                <div id="barcodeScanner" className="barcodeScanner">
                    <Question question={question} />
                    <button id="bypassBarcodeScanButton" onClick={() => this.handleBarcodeScanResults(this.getBarcodeTextResultsForDebug())}
                            className="w3-button w3-block w3-center w3-indigo w3-small w3-padding-large">
                        Press to Simulate Scan
                    </button>
                </div>
            );
        }
        else {
            return (
                <div id="barcodeScanner" className="barcodeScanner">
                    <Question question={question} />
                    {flashButton}
                    <video width="400" height="300" className="dce-video" playsInline={true}></video>
                </div>
            );
        }
    }
}

BarcodeScanner.propTypes = {
    question: PropTypes.object,
    store: PropTypes.object,
    processPicture: PropTypes.func,
    processClick: PropTypes.func
};

export default BarcodeScanner;
